import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './ServiceWorkItem.css';
import { resolveServiceMediaUrl } from '../utils/serviceContent';
import { useLocale } from '../context/LocaleContext';
import { richTextToPlainText } from '../utils/richText';

const ServiceWorkItem = ({ work, defaultDetailLink }) => {
  const { t } = useTranslation();
  const { localePath } = useLocale();
  const detailLink = work.detailLink || defaultDetailLink || `/projects/${work.id}`;
  const isExternal = /^https?:\/\//i.test(detailLink);
  const resolvedDetailLink = isExternal ? detailLink : localePath(detailLink);
  const descriptionPreview = richTextToPlainText(work.description || '');
  const linkContent = (
    <>
      {t('serviceUi.portfolio.projectMore')}
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </>
  );
  return (
    <div className="service-work-item">
      {work.image && <div className="service-work-image-wrapper">
        <img 
          src={resolveServiceMediaUrl(work.image)}
          alt={work.title}
          className="service-work-image"
        />
      </div>}
      <div className="service-work-content">
        <div className="service-work-header">
          <h4 className="service-work-title">{work.title}</h4>
          {work.technologies && work.technologies.length > 0 && (
            <div className="service-work-technologies">
              {work.technologies.map((tech, index) => (
                <span key={index} className="service-work-tech-tag">
                  {tech}
                </span>
              ))}
            </div>
          )}
        </div>
        {descriptionPreview && (
          <p className="service-work-description">{descriptionPreview}</p>
        )}
        <div className="service-work-footer">
          {isExternal
            ? <a href={resolvedDetailLink} target="_blank" rel="noreferrer" className="service-work-link-btn">{linkContent}</a>
            : <Link to={resolvedDetailLink} className="service-work-link-btn">{linkContent}</Link>}
        </div>
      </div>
    </div>
  );
};

export default ServiceWorkItem;
